import { StsBackendOperation } from '../../../sts-backend-operation';

/** Parameters for deleting a draft worksheet submission. */
export type DeleteDraftSubmissionParams = {
    /** The ID of the draft submission to delete. */
    submissionId: string;
};

/**
 * Deletes a draft worksheet submission.
 * Only draft submissions can be deleted; submitted ones are permanent.
 */
export class DeleteDraftSubmission extends StsBackendOperation {
    /**
     * Delete a draft worksheet submission by its ID.
     *
     * @param params - the submission to delete
     * @returns true if the deletion succeeded, false if it failed
     */
    async exec(params: DeleteDraftSubmissionParams): Promise<boolean> {
        const { submissionId } = params;
        const response = await this.client.deleteDraftWorksheetSubmission({ submissionId });

        return response.success;
    }
}
